<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="6">
        <div>
          <el-input
            v-model="key"
            placeholder="请输入关键字或词"
            class="input-with-select"
            size="small"
            suffix-icon="el-icon-search"
          />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <div>
          <el-button
            v-permission="['紧急揭盲结果导出']"
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            >导出结果</el-button
          >
          <el-button
            v-permission="['紧急揭盲紧急揭盲']"
            v-if="project.status !== '项目创建中'"
            type="primary"
            icon="el-icon-circle-plus-outline"
            size="small"
            @click="handleEnd"
            >紧急揭盲</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        stripe
        size="mini"
        :data="roleData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        border
        :cell-style="cellStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column type="selection" />
        <el-table-column prop="choice_code_combination" label="筛选号" />
        <el-table-column prop="name_abb" label="姓名缩写">
          <template slot-scope="scope">
            <div style="font-size: 12px">{{ scope.row.name_abb }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="project.is_need_layer"
          label="分层因素"
          prop="layer_str"
          width="268"
        />
        <el-table-column label="随机号" prop="random_code_combination" />
        <el-table-column label="入组中心" prop="unit_name" width="302" />
        <el-table-column label="主要研究者" prop="doctor_name" />
        <el-table-column label="揭盲人" prop="create_user_name" />
        <el-table-column
          v-if="project.in_group_time_name"
          :label="project.in_group_time_name"
          prop="reg_time"
        />
        <el-table-column label="状态" prop="status">
          <template>
            <div>已揭盲</div>
          </template>
        </el-table-column>
        <el-table-column label="试验组名" prop="group_name" />
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-link
              v-permission="['紧急揭盲查看']"
              type="primary"
              :underline="false"
              class="edit"
              @click="handleUrgentView(scope.row)"
              >查看</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--脱落-->
    <el-dialog
      center
      :visible.sync="dialogVisibleEnd"
      :close-on-click-modal="false"
      width="40%"
    >
      <div slot="title" class="title">受试者紧急揭盲</div>
      <div class="proInfo sub_style">
        <el-row class="row">
          <el-col :span="6">选择中心：</el-col>
          <el-col :span="18">
            <el-select
              v-model="unit_id"
              placeholder="请选择"
              size="mini"
              class="right"
              @change="changeUnit"
            >
              <el-option
                v-for="item in unit_list"
                :key="item.value"
                :label="item.text"
                :value="item.id"
                :disabled="!item.enable"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="6">筛选号：</el-col>
          <el-col :span="18">
            <el-select
              v-model="choice_code_combination_list"
              placeholder="请选择"
              size="mini"
              class="right"
              :disabled="!unit_id"
            >
              <el-option
                v-for="item in users_list"
                :key="item.id"
                :label="item.choice_code_combination"
                :value="item.choice_code_combination"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">紧急揭盲原因记录：</el-col>
          <el-col :span="18">
            <el-input
              v-model="reason"
              size="mini"
              type="textarea"
              placeholder="请输入内容"
              show-word-limit
            />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          size="mini"
          type="primary"
          :loading="is_loading"
          @click="handleUrgent"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCancelUrgent">取 消</el-button>
      </span>
    </el-dialog>
    <!--导出-->
    <el-dialog
      center
      :visible.sync="dialogVisibleExport"
      :close-on-click-modal="false"
      width="40%"
    >
      <div slot="title" class="title">受试者登记信息导出</div>
      <div class="proInfo">
        <el-row :gutter="20">
          <el-col :span="6" style="text-align: right">文件类型：</el-col>
          <el-col :span="18" style="text-align: left">
            <el-radio-group v-model="the_type">
              <el-radio label="excel">excel</el-radio>
              <el-radio label="pdf">pdf</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="6" style="text-align: right">导出到：</el-col>
          <el-col :span="18" style="text-align: left">
            <el-radio-group v-model="to">
              <el-radio label="本地">本地</el-radio>
              <el-radio label="邮箱">邮箱</el-radio>
              <el-radio label="本地及邮箱">本地及邮箱</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <!-- <el-row class="row">
          <el-col :span="6" class="left" style="margin-top:2px;">文件类型：</el-col>
          <el-col :span="18">
            <el-select v-model="the_type" size="mini" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="left">导出到：</el-col>
          <el-col :span="18">
            <el-select v-model="to" size="mini" placeholder="请选择">
              <el-option
                v-for="item in optionsTo"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
        </el-row> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleSubClick"
          >确 定</el-button
        >
        <el-button size="mini" @click="cancel()">取 消</el-button>
      </span>
    </el-dialog>
    <!--查看-->
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="viewDialogVisible"
      width="60%"
    >
      <div slot="title" class="title">受试者记录</div>
      <div class="proInfo" id="printbox">
        <div
          style="
            display: flex;
            margin-bottom: 20px;
            justify-content: space-between;
          "
        >
          <div class="tableItem">
            <span>单位：</span>
            <span>{{ unitName }}</span>
          </div>
          <div class="tableItem">
            <span>筛选号：</span><span>{{ choiceCode }}</span>
          </div>
          <div class="tableItem">
            <span>姓名缩写：</span><span>{{ nameAbb }}</span>
          </div>
          <div class="tableItem">
            <span>随机号：</span><span>{{ randomCode }}</span>
          </div>
        </div>
        <el-table
          size="mini"
          :data="tableData"
          border
          :header-cell-style="tableHeaderColor"
          style="width: 100%"
          :cell-style="cellStyle"
        >
          <el-table-column prop="action" label="操作" width="180" />
          <el-table-column prop="create_user_name" label="操作人" width="180" />
          <el-table-column prop="create_time" label="操作时间" />
          <el-table-column prop="remarks" label="记录" />
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="goPrint">打 印</el-button>
        <el-button size="mini" type="primary" @click="handleCloseUrgent"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getProjectId } from "@/utils/auth";
import { unitMyAllResearchCenter, getUnblindSubjectByUnit } from "@/api/unit";
import { projectDetailApi } from "@/api/project";
import {
  urgent,
  unblindPage,
  exportFile,
  detail,
  logs,
  subjectExportApi,
} from "@/api/subjects";
import { goPrintFn } from "@/utils/goPrintFn";
export default {
  name: "Urgent",
  data() {
    return {
      timer: "",
      multipleSelection: [],
      cellStyle: {
        textAlign: "center",
      },
      currentPage: 1,
      pageSize: 10,
      total: null,
      roleData: [],
      unit_id: "",
      choice_code_combination_list: "",
      users_list: [],
      unit_list: [],
      proId: "",
      key: "",
      dialogVisibleEnd: false,
      is_loading: false,
      dialogVisibleExport: false,
      reason: "",
      choice_code_combination: "",
      options: [
        {
          label: "excel",
          value: "excel",
        },
        {
          label: "pdf",
          value: "pdf",
        },
      ],
      optionsTo: [
        {
          label: "本地",
          value: "本地",
        },
        {
          label: "邮箱",
          value: "邮箱",
        },
        {
          label: "本地及邮箱",
          value: "本地及邮箱",
        },
      ],
      the_type: "",
      to: "",
      viewDialogVisible: false,
      tableData: [],
      choiceCode: "",
      nameAbb: "",
      randomCode: "",
      doctorName: "",
      unitName: "",
      viewId: "",
      loading: false,
      project: {},
    };
  },
  created() {
    this.proId = getProjectId();
    this.getFall();
    this.getUnitList();
    // 获取项目详情
    projectDetailApi(this, this.proId, (res) => {
      if (res && res.code === 0) {
        this.project = res.data;
      }
    });
  },
  methods: {
    changeUnit(ids) {
      this.choice_code_combination_list = "";
      getUnblindSubjectByUnit({
        project_id: this.proId,
        unit_id_list: ids,
      }).then((res) => {
        if (res && res.success) {
          this.users_list = res.data;
        }
      });
    },
    getUnitList() {
      // 获取所有单位，用来筛选入组中心
      unitMyAllResearchCenter(this, this.proId, (res) => {
        if (res.data && res.data.length > 0) {
          this.unit_list = res.data.map((item) => {
            const obj = {};
            obj.text = item.name;
            obj.value = item.name;
            obj.id = item.id;
            obj.doctor = item.main_researchers;
            obj.enable = item.enable;
            return obj;
          });
        } else {
          this.unit_list = [];
        }
      });
    },
    handleCloseUrgent() {
      this.viewId = "";
      this.viewDialogVisible = false;
    },
    handleUrgentView(row) {
      this.viewDialogVisible = true;
      this.viewId = row.id;
      const params = {
        project_id: this.proId,
        id: row.id,
      };
      detail(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.choiceCode = res.data.choice_code_combination;
            this.nameAbb = res.data.name_abb;
            this.randomCode = res.data.random_code_combination;
            this.unitName = res.data.unit_name;
            this.getHasLogs();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    getHasLogs() {
      const params = {
        project_id: this.proId,
        id: this.viewId,
      };
      logs(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.tableData = res.data;
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleExport() {
      this.dialogVisibleExport = true;
    },
    val() {
      if (!this.the_type) {
        this.$message({
          message: "请选择文件类型",
          type: "warning",
        });
        return false;
      }
      if (!this.to) {
        this.$message({
          message: "请选择导出地址",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    export_excel_file(export_data) {
      //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
      let blogw = new Blob([export_data], {
        type: this.$store.getters.file_type,
      });
      let link = document.createElement("a");
      let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
      link.href = objectUrl;
      link.download = this.$store.getters.file_name;
      link.click();
      window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
    },
    handleSubClick() {
      if (this.val()) {
        let id_list = this.multipleSelection.map((item) => {
          return item.id;
        });
        if (this.to === "本地") {
          // const baseUrl = process.env.VUE_APP_BASE_API + '/v1.0/iwrs/subject/export?project_id=' + this.proId + '&the_type=' + this.the_type + '&to=' + this.to + '&stype=紧急揭盲' + '&hihih'
          // window.open(
          //   baseUrl,
          //   '_self'
          // )
          exportFile({
            project_id: this.proId,
            the_type: this.the_type,
            to: this.to,
            stype: "紧急揭盲",
            id_list,
          }).then((res) => {
            this.export_excel_file(res);
            this.$message({
              message: "下载成功",
              type: "success",
            });
            this.dialogVisibleExport = false;
          });
        } else {
          const params = {
            project_id: this.proId,
            the_type: this.the_type,
            to: this.to,
            stype: "紧急揭盲",
            id_list,
          };
          if (this.to === "邮箱") {
            subjectExportApi(this, params, (res) => {
              this.$message({
                message: "下载成功",
                type: "success",
              });
              this.cancel();
            });
          } else {
            exportFile(params)
              .then((res) => {
                this.export_excel_file(res);
                this.$message({
                  message: "下载成功",
                  type: "success",
                });
                this.cancel();
              })
              .catch((res) => {
                console.log(res.msg);
              });
          }
        }
      }
    },
    cancel() {
      this.dialogVisibleExport = false;
      this.to = "";
      this.the_type = "";
    },
    getFall() {
      this.loading = true;
      const params = {
        project_id: this.proId,
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
      };
      unblindPage(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.loading = false;
            if (res.data && res.data.length > 0) {
              this.roleData = res.data;
              this.total = res.total;
            } else {
              this.roleData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleEnd() {
      this.dialogVisibleEnd = true;
    },
    handleUrgent() {
      const params = {
        project_id: this.proId,
        unit_id: new Array(this.unit_id),
        reason: this.reason,
        choice_code_combination_list: new Array(
          this.choice_code_combination_list
        ),
      };
      if (this.unit_id && this.reason && this.choice_code_combination_list) {
        this.$confirm("此操作将紧急揭盲该受试者, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.is_loading = true;
          urgent(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.handleCancelUrgent();
                this.$message({
                  message: res.msg,
                  type: "success",
                });
              } else {
                this.$message(res.msg);
              }
            })
            .finally(() => {
              this.is_loading = false;
            });
        });
      } else {
        this.$message.error("信息填写不完整");
      }
    },
    handleCancelUrgent() {
      this.reason = "";
      this.choice_code_combination_list = "";
      this.unit_id = "";
      this.dialogVisibleEnd = false;
      this.getFall();
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getFall();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getFall();
    },
    // 修改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    goPrint() {
      goPrintFn("受试者记录", "printbox");
    },
  },
  watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getFall, 500);
    },
  },
};
</script>

<style scoped>
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.left {
  line-height: 26px;
  text-align: right;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
.diaBg {
  background-color: #f0f5ff;
  padding: 20px;
}
</style>
